module.exports = __webpack_public_path__ + "static/media/testimonial_image.e6ba9d65.webp";